<div class="create-event-tag-result">
  <div class="create-event-tag-result__input-field">
    <div>{{ 'EDIT_CUSTOM_EVENT.NAME' | translate }}</div>
    <input
      class="ui-input"
      [(ngModel)]="customEvent.name"
      [placeholder]="'EDIT_CUSTOM_EVENT.PLACEHOLDERS.UNTITLED' | translate"
    />
  </div>

  <div class="create-event-tag-result__input-field">
    <div>{{ 'EDIT_CUSTOM_EVENT.VIDEO_LENGTH' | translate }}</div>
    <div class="create-event-tag-result__video-length">
      <input
        class="ui-input"
        type="number"
        [(ngModel)]="customEvent.videoLength"
        [min]="minVideoLength"
        [max]="maxVideoLength"
      />
      <div class="create-event-tag-result__suffix">{{ 'EDIT_CUSTOM_EVENT.SEC' | translate }}</div>
    </div>
  </div>

  <div class="create-event-tag-result__fields">
    <div class="create-event-tag-result__fields-toolbar">
      <div>{{ 'EDIT_CUSTOM_EVENT.LIMIT' | translate: { selected: customEvent.fields.length } }}</div>
      <ui-button
        type="noBorderPrimary"
        [text]="'EDIT_CUSTOM_EVENT.BUTTONS.ADD' | translate"
        [disabled]="customEvent.fields.length >= maxFields"
        (clickAction)="addField()"
      ></ui-button>
    </div>

    @if (tableConfig(); as config) {
      <div class="create-event-tag-result__table">
        <ui-dataset-table
          [data]="customEvent.fields"
          [config]="config"
          (rowAction)="onRowAction($event)"
        ></ui-dataset-table>
      </div>
    }
  </div>

  <!-- CELL TEMPLATES -->
  <ng-template #nameCell let-row>
    <input
      class="ui-input narrow-input-40"
      [(ngModel)]="row.name"
      [placeholder]="'EDIT_CUSTOM_EVENT.PLACEHOLDERS.NAME' | translate"
    />
  </ng-template>

  <ng-template #typeCell let-row>
    <mat-select
      class="ui-selector create-event-tag-result__type-select"
      [placeholder]="'EDIT_CUSTOM_EVENT.PLACEHOLDERS.TYPE' | translate"
      [(ngModel)]="row.type"
    >
      <mat-option [value]="customEventFieldType.Text">
        {{ 'EDIT_CUSTOM_EVENT.TYPES.TEXT' | translate }}
      </mat-option>
      <mat-option [value]="customEventFieldType.Boolean">
        {{ 'EDIT_CUSTOM_EVENT.TYPES.BOOLEAN' | translate }}
      </mat-option>
      <mat-option [value]="customEventFieldType.Number">
        {{ 'EDIT_CUSTOM_EVENT.TYPES.NUMBER' | translate }}
      </mat-option>
      <mat-option [value]="customEventFieldType.Decimal">
        {{ 'EDIT_CUSTOM_EVENT.TYPES.DECIMAL' | translate }}
      </mat-option>
    </mat-select>
  </ng-template>
</div>
